export const setStrokeDasharray = (self, { el, stroke_dasharray }) => {
  self._checkNoProcessingTask();
  const stroke = self._getStrokeThrowable();
  stroke.setStrokeDasharray({
    el,
    stroke_dasharray,
  });
};
